export default __webpack_public_path__ + "static/media/a1.9e617b14.jpeg";